import DOMPurify from "dompurify";

export const htmlSanitizer = (htmlString?: string): string => {
  if (!htmlString?.length) return "";

  return DOMPurify.sanitize(htmlString, { USE_PROFILES: { html: true } });
};
